<template>
    <div>
        <portal to="page-header">{{ $t('Change Password') }}</portal>

        <portal to="actions">
            <back-button
                :route-name="'pos.home'"
            >{{ $t('Home') }}</back-button>
        </portal>

        <form @submit.prevent="submit">
            <div class="flex flex-wrap">
                <div class="px-3 w-full">
                    <card>
                        <div class="flex field-wrapper w-full">
                            <div class="px-4 py-2 w-1/2 sm:w-1/4">
                                <label for="current_password" class="inline-block text-gray-500 pt-2 leading-tight">
                                    {{ $t('Current Password') }}
                                </label>
                            </div>
                            <div class="py-2 px-4 w-1/2 sm:w-3/4">
                                <JetInput
                                    id="current_password"
                                    ref="current_password"
                                    type="password"
                                    :placeholder="$t('Current Password')"
                                    v-model="form.current_password"
                                    class="w-full form-control form-input"
                                    required
                                    autofocus
                                />
                                <JetInputError :message="errors.current_password" class="mt-2" />
                            </div>
                        </div>
                        <div class="flex field-wrapper w-full">
                            <div class="px-4 py-2 w-1/2 sm:w-1/4">
                                <label for="password" class="inline-block text-gray-500 pt-2 leading-tight">
                                    {{ $t('New Password') }}
                                </label>
                            </div>
                            <div class="py-2 px-4 w-1/2 sm:w-3/4">
                                <JetInput
                                    id="password"
                                    ref="password"
                                    type="password"
                                    :placeholder="$t('New Password')"
                                    v-model="form.password"
                                    class="w-full form-control form-input"
                                    required
                                    autofocus
                                />
                                <JetInputError :message="errors.password" class="mt-2" />
                            </div>
                        </div>
                        <div class="flex field-wrapper w-full">
                            <div class="px-4 py-2 w-1/2 sm:w-1/4">
                                <label for="password_confirmation" class="inline-block text-gray-500 pt-2 leading-tight">
                                    {{ $t('New Password Confirmation') }}
                                </label>
                            </div>
                            <div class="py-2 px-4 w-1/2 sm:w-3/4">
                                <JetInput
                                    id="password_confirmation"
                                    ref="password_confirmation"
                                    type="password"
                                    :placeholder="$t('New Password Confirmation')"
                                    v-model="form.password_confirmation"
                                    class="w-full form-control form-input"
                                    required
                                    autofocus
                                />
                                <JetInputError :message="errors.password_confirmation" class="mt-2" />
                            </div>
                        </div>
                    </card>
                </div>
            </div>

            <div class="px-3 flex justify-between items-center">
                <div class="max-w-md mr-4"></div>
                <JetButton :processing="form.processing" class="mt-8 transition-colors duration-150 bg-purple-600 border border-transparent rounded active:bg-purple-600 hover:bg-purple-700 focus:outline-none focus:shadow-outline-purple" type="submit">
                    {{ $t('Change Password') }}
                </JetButton>
            </div>
        </form>
    </div>
</template>

<script>
import JetButton from '../../Jetstream/Button';
import JetFormSection from '../../Jetstream/FormSection';
import JetInput from '../../Jetstream/Input';
import JetInputError from '../../Jetstream/InputError';
import JetLabel from '../../Jetstream/Label';

import PageHeader from '../Components/PageHeader';
import Card from '../Components/Card';
import BackButton from '../Components/BackButton';

export default {
    name: "ChangePassword",
    components: {BackButton, JetButton, JetFormSection, JetInput, JetInputError, JetLabel, PageHeader, Card},
    props: {
        errors: Object
    },
    metaInfo() {
        return {
            title: this.title
        }
    },
    computed: {
        title () {
            return this.$t('Change Password');
        }
    },
    data() {
        return {
            form: {
                current_password: '',
                password: '',
                password_confirmation: '',
                processing: false
            },
        }
    },
    methods: {
        async submit() {
            this.processing = true;
            await this.$inertia.post(route('user.requestChangePassword').url(), this.form);
            this.processing = false;
        }
    },
    mounted() {
        this.$refs.current_password.focus();
    }
}
</script>
